import React, { useContext, useEffect, useState } from 'react';
import { Context as Auth } from '../../../services/auth/AuthContext';
import Spinner from '../../../components/navigation/Spinner';
import { Col, Row } from 'antd';
import { getIdToken } from 'firebase/auth';
import { getAccountByQuery } from '../../../services/user.service';
import { getCenterById } from '../../../services/center.service';
import ResumeDashboard from '../../../components/cards/CardResumeDashboard';
import { DollarOutlined, CalendarOutlined, BarChartOutlined } from '@ant-design/icons';
import { capitalize, capitalizeAll } from '../../../utils/utils';
import { useTranslation } from 'react-i18next';
import { getProgramSessionByQuery } from '../../../services/programsession.service';
import { getBookingByUserId } from '../../../services/booking.service';
import moment from 'moment';
import 'moment/locale/es';

const UserHome = (props) => {
  const { user } = useContext(Auth);
  // const [devices, setDevices] = useState([]);
  const [center, setCenter] = useState(null);
  const [users, setUsers] = useState([]);
  const [programSessions, setProgramSessions] = useState([]);
  const [organizers, setOrganizers] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  // const [programSessions, setProgramSessions] = useState([]);

  useEffect(() => {
    if (user.account) {
      loadUserSessions();
    }
  }, [user.account]);

  const loadUserSessions = async () => {
    const { status, data } = await getProgramSessionByQuery({ account: user.account._id }, user.token);
    if (status === 200) {
      setProgramSessions(data.data);
      await loadCenterId();
      setLoading(false);
    }
  };

  const loadUserBookings = async (userId) => {
    const { status, data } = await getBookingByUserId(userId, user.token);
    if (status === 200) {
      setBookings(data.data);
      setLoading(false);
    }
  };

  const loadCenterId = async () => {
    const { status, data } = await getCenterById(user.account.center, user.token);
    if (status === 200) {
      setCenter(data.data);
      if (data.data.plan[2] === '1') {
        await loadUserBookings(user.account._id);
      }
      return data.data;
    }
  };

  if (loading) {
    return <Spinner/>;
  }

  return (
    <>
      <Row justify='center' style={{ gap: 15, marginBottom: 25 }}>
        {/* <ResumeDashboard title={capitalizeAll(t('users'))} icon={<TeamOutlined />} value={users.length}/> */}
        <ResumeDashboard title={capitalizeAll(t('sessions'))} icon={<BarChartOutlined />} value={programSessions.length}/>
        <ResumeDashboard title={capitalizeAll(t('credits'))} icon={<DollarOutlined />} value={user.account.credits}/>
        {/* <ResumeDashboard title={'Earnings'} icon={<DollarOutlined />} value={'0€'}/> */}
      </Row>
      <Row>
        <Col xs = {24} md={12}>
          {center && center.plan[2] === '1' && (
            <div>
              <h2><CalendarOutlined /> {capitalize(t('myBookings'))}</h2>
              {bookings.length === 0 && (
                <div>{capitalize(t('noBookingsFound'))}</div>
              )}
              {bookings.map((booking) => (
                <>{!booking.isQueue && (
                  <div key={booking._id} style={{ border: '1px solid #ccc', borderRadius: 5, padding: 10, marginBottom: 10 }}>
                    <div><strong>{capitalize(t('date'))}:</strong> {moment(booking.start).format('LL')}</div>
                    <div><strong>{capitalize(t('hour'))}:</strong> {moment(booking.start).format('LT')} - {moment(booking.end).format('LT')}</div>
                    <div><strong>{capitalize(t('name'))}:</strong> {capitalize(booking.name)}</div>
                    <div><strong>{capitalize(t('description'))}:</strong> {capitalize(booking.description)}</div>
                    {booking.isQueue && (<div style={{
                      color: 'darkorange'
                    }}>{capitalize(t('isQueueBooking'))}</div>)}
                    {booking.isGroup && (<div style={{
                      color: 'green'
                    }}
                    >{capitalize(t('isGroupBooking'))}</div>)}
                  </div>
                )}</>
              ))}
            </div>
          )}
          <br />
        </Col>
      </Row>

    </>
  );
};

export default UserHome;
